<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <!-- <router-link to="/manage">SKU管理</router-link>
      <span class="arrow"><i class="iconfont icon-arrow"></i></span>
      <span>商品管理</span> -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <p class="flex-rowl">
            <i class="iconfont icon-danxuanyixuan"></i> 全选
          </p>
          <router-link to="/commondityIndex/addCommondity"
            ><p class="flex-rowl">
              <i class="iconfont icon-xinzeng"></i> 新增
            </p></router-link
          >
        </div>
        <div class="filter flex-rowr">
          <div class="screen_wrap flex-rowr">
            <div
              class="txt"
              :class="params.commoditystate == 1 ? 'active' : ''"
              @click="handleState(1)"
            >
              已上架
            </div>
            <div
              class="txt"
              :class="params.commoditystate == 0 ? 'active' : ''"
              @click="handleState(0)"
            >
              已下架
            </div>
            <div
              class="txt"
              :class="params.commoditystate == 2 ? 'active' : ''"
              @click="handleState(2)"
            >
              所有商品
            </div>
          </div>
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="关键词查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示商品列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
          <div class="sort_wrap flex-rowc">
            <span>快速数据</span>
            <i class="iconfont icon-zhexiantu"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="check">
                <i class="iconfont icon-danxuanyixuan"></i>
              </div>
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.img" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <h1>商品名称：</h1>
                    <p>
                      <span>{{ item.commodityname }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_e }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_y }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_m }}</span>
                    </p>
                    <p>
                      <span>{{ item.commodityname_t }}</span>
                    </p>
                    <p>
                      单款混选起批数量： <span>{{ item.startnum1 }}</span
                      ><span>件/起批</span>
                    </p>
                    <div class="ercode" @click="handleShowErcode(item)">
                      <el-image
                        style="height: 50px"
                        :src="item.ercode"
                      ></el-image>
                    </div>
                  </div>
                  <div class="block">
                    <!-- <p>
                      商品ID：<span>{{ item.id }}</span>
                    </p> -->
                    <p>
                      企业名称：<span>{{
                        item.qyname ? item.qyname : item.qy_accountid
                      }}</span>
                    </p>
                    <p>
                      SKU采购编码：<span>{{ item.sku }}</span>
                    </p>
                    <p>
                      品牌标签：<span>{{ item.brandname }}</span>
                    </p>
                    <p>
                      ISBN编码：<span>{{ item.ISBN }}</span>
                    </p>
                    <p>
                      是否精品推荐：<span>{{ item.isintro }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      是否上架：<span>{{ item.commoditystate }}</span>
                    </p>
                    <p>
                      销售状态：<span>{{ item.salestate }}</span>
                    </p>
                    <p>
                      限购状态：<span v-if="item.islimit">{{
                        item.islimit == "不限购"
                          ? item.islimit
                          : "每人限购/" + item.limitnum + "件"
                      }}</span>
                    </p>
                    <p>
                      所属分类：<span v-if="item.labelname"
                        >{{ item.labelname }}、</span
                      >
                      <span v-if="item.labelname2"
                        >{{ item.labelname2 }}、</span
                      >
                      <span v-if="item.labelname3">{{ item.labelname3 }}</span>
                    </p>
                    <p>
                      商品类型：<span>{{ item.comtype }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      结算类型：<span>{{ item.paytype }}</span>
                    </p>
                    <p>
                      基础零售价：<span v-if="item.price"
                        >¥ {{ item.price }}/件</span
                      >
                    </p>
                    <p>
                      普通用户积分价：<span>{{ item.userscore1 }}</span>
                    </p>
                    <p>
                      商务合作用户积分价：<span>{{ item.userscore2 }}</span>
                    </p>
                    <p>
                      企业积分价：<span>{{ item.userscore3 }}</span>
                    </p>
                    <p>
                      批发售价：
                      <span v-if="item.groupprice">¥ {{ item.groupprice }}</span
                      ><span>/件</span>
                    </p>
                  </div>
                  <!-- <div class="block">
                    <p>
                      批发商品组规格： <span>{{ item.groupnum }}</span
                      ><span>件/每组</span>
                    </p>
                    
                    <p>
                      混样多选起批数量： <span>{{ item.startnum2 }}</span
                      ><span>组</span>
                    </p>
                  </div> -->
                </div>
                <div class="operation_box flex-colt">
                  <a href="javascript:;" @click="handleGo(item.id,'cBaseinfo')">基础信息设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cShopAttachment')">商品配件设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cImages')">产品图片设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cSalesParams')">销售参数设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cAttrLabel')">属性标签&规格变量设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cDetail')">商品详情设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cLabel')">商品标签设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'addRule')">零售物流&发货信息参数</a>
                  <a href="javascript:;" @click="handleGo(item.id,'addRulePf')">批发物流&发货信息参数</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cOthers')">其他设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cMultiPrice')">多币种价格设置</a>
                  <a href="javascript:;" @click="handleGo(item.id,'cProductionCode')">商品生产组码管理</a>
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cBaseinfo/' + item.id"
                    target="_blank"
                    >基础信息设置</router-link
                  > -->
                  <!-- <router-link
                    :to="`/commondityIndex/cManageEdit/cShopAttachment/${item.id}`"
                    target="_blank"
                    >商品配件设置</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cImages/' + item.id"
                    target="_blank"
                    >产品图片设置</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cSalesParams/' + item.id"
                    target="_blank"
                    >销售参数设置</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cAttrLabel/' + item.id"
                    target="_blank"
                    >属性标签&规格变量设置</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cDetail/' + item.id"
                    target="_blank"
                    >商品详情设置</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cIntroDetailSet/' + item.id"
                    >商品介绍详情管理</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cLabel/' + item.id"
                    target="_blank"
                    >商品标签设置</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/logsticsIndex/addRule/' + item.id"
                    target="_blank"
                    >零售物流&发货信息参数</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/logsticsIndex/addRulePf/' + item.id"
                    target="_blank"
                    >批发物流&发货信息参数</router-link
                  > -->
                  <!-- <router-link
                    :to="'/commondityIndex/cManageEdit/cOthers/' + item.id"
                    target="_blank"
                    >其他设置</router-link
                  > -->
                </div>
              </div>
            </div>
            <div class="shop_more"></div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 弹窗内容展示 start -->
    <div class="custom_dialog" v-show="isShow">
      <div class="custom_wrap">
        <div class="custom_diaog_body">
          <div class="ercode">
            <el-image style="height: 430px" :src="shopPopupImg"></el-image>
          </div>
          <div class="download">
            <a :href="shopPopupImg" target="_blank" download="image.png"
              >下载图片</a
            >
          </div>
        </div>
        <div class="close" @click="isShow = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </div>
    <!-- 弹窗内容展示 end -->
  </div>
</template>

<script>
import { getMenuAuthTwo, getCommondity, encryptstringadd } from "../../api/api";
// import { getShopErcodeImg } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cManageIndex",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      isShow: false,
      loading: false,
      listTotal: 0,
      dataList: [],
      params: {
        Page: 1,
        PageSize: 10,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: 0,
      },

      dataItem: "", // 单个商品
      shopPopupImg: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.params.qyid = userInfo.qy.id;
    } else {
      this.params.qyid = 0;
    }
    this.roleId = userInfo.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
    this.initData();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleCurrentChange(e) {
      this.params.Page = e;
      // this.dataList = [];
      this.initData();
    },
    handleSearch() {
      this.params.Page = 1;
      this.initData();
    },
    handleState(type) {
      this.params.Page = 1;
      this.params.commoditystate = type;
      this.initData();
    },
    // 重置
    handleRest() {
      this.params.Page = 1
      this.params.commoditystate = 1
      this.params.keyword = ''
      this.initData()
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getCommondity(params).then((res) => {
        this.listTotal = res.total;
        // this.dataList = res.list.concat(...this.dataList);
        this.dataList = res.list;
        this.loading = false;
        // this.dataList = this.dataList.concat(...res.list);
      });
    },

    // 触发滑动事件
    handleScroll(e) {
      let el = e.target;
      // let { listTotal, dataList } = this;
      //判断是否到达div容器底部
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        // if (listTotal > dataList.length) {
        //   this.params.Page += 1;
        //   this.initData();
        // }
      }
    },

    // 显示弹窗
    async handleShowErcode(item) {
      this.shopPopupImg = item.ercode;
      console.log(item, item.ercode, "===== item.recode");
      // let that = this;
      // // 根据tkid获取海报
      // let base64Img = await getShopErcodeImg(item.id);
      // // console.log(base64Img,'=======');

      // const reader = new FileReader();
      // reader.readAsDataURL(base64Img);
      // reader.onloadend = function () {
      //   console.log(reader,'====reader');
      //   that.shopPopupImg = reader.result;
      //   // 在此处使用 base64Data 进行后续操作，如显示图片或发送给服务器等
      // };
      // getShopErcodeImg(item.id).then(res => {
      //   // console.log(res,'======');
      //   // 根据tkid获取海报
      //   const reader = new FileReader();
      //   reader.readAsDataURL(res);
      //   reader.onloadend = function () {
      //     console.log(reader,'====reader');
      //     that.shopPopupImg = reader.result;
      //     // 在此处使用 base64Data 进行后续操作，如显示图片或发送给服务器等
      //   };
      //   // this.shopPopupImg = res
      // })
      // this.dataItem = item;
      this.isShow = true;
    },

    handleGo(id, name) {
       this.encryptstringadd(name, { id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          // this.$router.push({
          //   name,
          //   params,
          // })
          window.open(this.$router.resolve({ name, params }).href, '_blank');
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .main_container {
    .screen_wrap {
      font-size: 14px;
      margin-right: 30px;
      .txt {
        cursor: pointer;
        &.active {
          font-size: 16px;
          color: red;
        }
        &:nth-child(2) {
          margin: 0 20px;
        }
      }
    }
    .select_add {
      p {
        &:last-child {
          margin-left: 49px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .ercode {
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .custom_dialog {
    .custom_wrap {
      width: 500px;
      height: 500px;
      .custom_diaog_body {
        height: 100%;
        box-sizing: border-box;
        // padding-top: 50px;
        .ercode {
          text-align: center;
          // margin-bottom: 32px;
        }
        .txt {
          p {
            text-align: center;
            font-size: 20px;
            color: #000000;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 30px;
            }
          }
        }
        .download {
          text-align: center;
          a {
            font-size: 18px;
            color: #0006ff;
            border-bottom: 1px solid #0006ff;
            padding-bottom: 5px;
          }
        }
      }
      .close {
        position: absolute;
        left: 50%;
        color: #fff;
        bottom: -50px;
        transform: translateX(-50%);
        cursor: pointer;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
}
</style>